import React, { useState } from 'react';
import '../../Css/uploadclient.css';

function ExcelUpload() {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`${apiUrl}/api/upload`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                setMessage(data.message);
            } else {
                setMessage('Error uploading file');
            }
        } catch (error) {
            setMessage('Error uploading file');
        }
    };

    return (
        <div className="UploadClient__container">
            <h2 className="UploadClient__title">Upload Excel File</h2>
            <form onSubmit={handleUpload} className="UploadClient__form">
                <input 
                    type="file" 
                    accept=".xlsx, .xls" 
                    onChange={handleFileChange} 
                    className="UploadClient__input"
                />
                <button type="submit" className="UploadClient__button">Upload</button>
            </form>
            {message && <p className="UploadClient__message">{message}</p>}
        </div>
    );
}

export default ExcelUpload;
